var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.534,
    height: 10.71,
    viewBox: "0 0 11.534 10.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.344,5.187a.5.5,0,0,0-.548-.041l-1.651.927a5.355,5.355,0,1,0,.935,6.3.453.453,0,0,0-.214-.626c-.223-.1-.424-.186-.635-.272a.54.54,0,0,0-.669.237,3.709,3.709,0,1,1-.936-4.788L6.981,7.85a.494.494,0,0,0,.109.906l3.76,1.056a.5.5,0,0,0,.61-.342l1.056-3.76A.5.5,0,0,0,12.344,5.187Z",
    transform: "translate(-0.998 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshImg);
export default __webpack_public_path__ + "static/media/refreshImg.f1f3e79d370438d627b1225a509f7d20.svg";
export { ForwardRef as ReactComponent };